var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:tick-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.64062 1.52832C5.51562 1.52832 2.14062 4.90332 2.14062 9.02832C2.14062 13.1533 5.51562 16.5283 9.64062 16.5283C13.7656 16.5283 17.1406 13.1533 17.1406 9.02832C17.1406 4.90332 13.7656 1.52832 9.64062 1.52832ZM9.64062 15.0283C6.33312 15.0283 3.64062 12.3358 3.64062 9.02832C3.64062 5.72082 6.33312 3.02832 9.64062 3.02832C12.9481 3.02832 15.6406 5.72082 15.6406 9.02832C15.6406 12.3358 12.9481 15.0283 9.64062 15.0283ZM13.0831 5.71332L8.14062 10.6558L6.19812 8.72082L5.14062 9.77832L8.14062 12.7783L14.1406 6.77832L13.0831 5.71332Z",
    fill: "#00A851"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cae8f55b22328b3c852ca8cb33218d3a.svg";
export { ForwardRef as ReactComponent };